export const GET_STREAMER_CARDS_REQUEST = 'GET_STREAMER_CARDS_REQUEST'

// The action for sending asynchronous request for streamer cards to the server
// (some splash screens can be shown in future)
export const requestStreamerCards = () => {
  return {
    type: GET_STREAMER_CARDS_REQUEST
  }
}

export const GET_STREAMER_CARDS_RESPONSE = 'GET_STREAMER_CARDS_RESPONSE'

// The action that is dispatched when the response with
// streamer cards is received from the server
export const receiveStreamerCards = (json) => {
  return {
    type: GET_STREAMER_CARDS_RESPONSE,
    streamerCards: json
  }
}

// Thunk that makes an asynchronous loading streamer cards from the server and
// dispatches corresponding "Request" and "Response" actions
export function fetchStreamerCards () {
  return (dispatch) => {
    dispatch(requestStreamerCards())

    return fetch(process.env.REACT_APP_BASE_URL + '/index/get_accounts')
      .then(
        response => response.json(),
        error => console.log('An error occurred.', error)
      )
      .then(json =>
        dispatch(receiveStreamerCards(json))
      )
  }
}
